import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import SearchResultHeader from "./SearchResultHeader";
import BusinessRecordHeader from "./BusinessRecordHeader";
import BusinessRecordDetail from "./BusinessRecordDetail";
import { getMenuItem } from "../common/PageHelper";

class BusinessResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReportId: null,
    };
  }

  onSelectReport = (selectedReportId) => {
    this.state = { selectedReportId };
  };

  render() {
    const results = [];
    let recCount = 0;
    let tabHeader = null;
    if (
      this.props.searchResultData !== undefined &&
      this.props.searchResultData !== null &&
      this.props.searchResultData !== ""
    ) {
      let records = _.get(
        this.props.searchResultData,
        `${
          Object.keys(this.props.searchResultData)[0]
        }.response[0].responsedocuments[0].record`
      );
      if (!records || records.length < 1) {
        records = _.get(
          this.props.searchResultData,
          `${
            Object.keys(this.props.searchResultData)[0]
          }.business[0].response[0].responsedocuments[0].record`
        );
      }
      const showNarrowSearchMessage = records && records.length > 25;
      tabHeader = (
        <SearchResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          log={_.get(
            this.props.searchResultData,
            `${Object.keys(this.props.searchResultData)[0]}.log[0]`
          )}
          {...this.props}
          printContent={this.props.printContent}
        />
      );

      if (records !== undefined) {
        _.forEach(records, (record, index) => {
          const header = (
            <Table.Row key={`Business_Header_Row_${index}`}>
              <Table.Cell>
                <BusinessRecordHeader
                  key={`Business_Header_Table_${index}`}
                  node={record}
                  index={index}
                  onSelectReport={this.onSelectReport}
                  {...this.props}
                  companyName={_.get(record, "companyName[0]._", "")}
                  userAccount={this.props.userAccount}
                />
              </Table.Cell>
            </Table.Row>
          );
          const body = (
            <Table.Row key={`Business_Body_Table_Row_${index}`}>
              <Table.Cell>
                <BusinessRecordDetail
                  key={`Business_Body_Table_${index}`}
                  node={record}
                  index={index}
                  {...this.props}
                />
              </Table.Cell>
            </Table.Row>
          );
          results.push(header);

          results.push(body);
          recCount += 1;
        });
      }
    }

    const tabs = [];
    tabs.push({
      menuItem: getMenuItem(
        this.props.userAccount.acctTheme,
        true,
        `${recCount} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {tabHeader}
          {results.length > 0 && (
            <Table stackable>
              <Table.Body>{results}</Table.Body>
            </Table>
          )}
        </Tab.Pane>
      ),
    });

    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(BusinessResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/BusinessResult.js